import { render, staticRenderFns } from "./DocumentVerification.vue?vue&type=template&id=47164f66&"
import script from "./DocumentVerification.vue?vue&type=script&lang=js&"
export * from "./DocumentVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports